import { useContext } from 'react';
import { parse } from 'url';

import { RoutesContext } from '@confluence/route-manager';

const MOBILE_APP_WITH_EDITING_PARENT_PRODUCT_QUERY_PARAMS = ['mobileAppWithEditing'];
const MOBILE_APP_WITH_COMMENTING_PARENT_PRODUCT_QUERY_PARAMS = [
	...MOBILE_APP_WITH_EDITING_PARENT_PRODUCT_QUERY_PARAMS,
	'mobileAppWithCommenting',
];
const MOBILE_APP_PARENT_PRODUCT_QUERY_PARAMS = [
	...MOBILE_APP_WITH_COMMENTING_PARENT_PRODUCT_QUERY_PARAMS,
	'mobileApp',
];

export const useIsMobileApp = (uri?: string) => {
	const { location, getQueryParams } = useContext(RoutesContext);
	let { parentProduct = '' } = getQueryParams();

	// If we have a uri string, we are being asked to check the query params from the uri
	if (uri) {
		({ parentProduct = '' } = parse(uri, true)?.query ?? {});
	} else if (location === null) {
		// If the RoutesContext is not available, we need to parse the query params from window.location
		({ parentProduct = '' } = parse(window?.location?.search, true)?.query ?? {});
	}

	return {
		isMobileApp: MOBILE_APP_PARENT_PRODUCT_QUERY_PARAMS.includes(parentProduct as string),
		isMobileAppWithCommenting: MOBILE_APP_WITH_COMMENTING_PARENT_PRODUCT_QUERY_PARAMS.includes(
			parentProduct as string,
		),
		isMobileAppWithEditing: MOBILE_APP_WITH_EDITING_PARENT_PRODUCT_QUERY_PARAMS.includes(
			parentProduct as string,
		),
	};
};
